import React, { useState, useRef, useEffect } from 'react';
import { Typeahead } from 'react-bootstrap-typeahead';
import { IBreedChooserProps } from './BreedChooser.types';
import { useFlowController, useFlowData } from '@adaptis/flow-components';
import _ from '../../imports/lodash-imports';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import './BreedChooser.scss';
import { getBreedsList } from '../../util/data-store';
import { AsyncTypeaheadWrapper } from '../WrapperComponent';

export default function BreedChooser(props: IBreedChooserProps) {
  const [isFocused, setIsFocused] = useState(false);
  const [isInvalid, setIsInvalid] = useState<boolean>(false);
  const { activeStep } = useFlowController();
  const { getData, setData } = useFlowData();
  const typeaheadRef = useRef<any>();
  const isMounted = useRef(true);
  const petType = getData('petType');
  const selectedBreed = getData(props.dataField ?? '');
  const [isTouched, setIsTouched] = useState<boolean>(
    selectedBreed && selectedBreed.length > 0
  );
  const [singleSelections, setSingleSelections] = useState<any[]>([]);
  const [breedsList, setBreedsList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  React.useEffect(() => {
    if (activeStep?.showValidations ?? false) {
      setIsTouched(true);
      validate();
    }
  }, [activeStep]);

  function onFocus() {
    setIsFocused(true);
  }
  function onBlur() {
    setIsFocused(false);
    setIsTouched(true);
    validate();
  }
  function labelOnClick() {
    typeaheadRef.current && typeaheadRef.current.focus();
  }

  function validate() {
    if (singleSelections.length === 0) {
      setIsInvalid(true);
    } else {
      setIsInvalid(false);
    }
  }

  useEffect(() => {
    validate();
  }, [singleSelections]);

  useEffect(() => {
    if (selectedBreed && !singleSelections.length) setSingleSelections([{ displayName: selectedBreed }]);
  }, [selectedBreed]);

  function onChange(selectedItemArray: any[]) {
    setSingleSelections(selectedItemArray);
    const selectedItem: string =
      selectedItemArray.toString() == '' ? '' : selectedItemArray[0];
    setData(props.dataField ?? '', _.get(selectedItem, 'displayName'));
  }

  async function loadBreedsList() {
    setIsLoading(true);
    let list = await getBreedsList(petType);
    if (isMounted.current) setBreedsList(list);
    else isMounted.current = true;
    setIsLoading(false);
  }

  useEffect(() => {
    if (petType) loadBreedsList();
  }, [petType]);

  function isInputEmpty() {
    if (typeaheadRef.current) {
      return typeaheadRef.current.getInput().value === '';
    }
    return true;
  }
  
  return (
    <div data-testid='BreedChooser' className='flc_breed-chooser'>
      <label
        className={
          (isFocused || singleSelections.length !== 0 || !isInputEmpty()
            ? 'selected '
            : '') + (isInvalid && isTouched ? 'invalid' : '')
        }
        onClick={labelOnClick}
      >
        {props.label}
      </label>
      <AsyncTypeaheadWrapper
        ref={typeaheadRef}
        id='flc_breed-chooser-typeahead'
        //@ts-ignore
        labelKey={(breed: any) => {
          return breed.displayName;
        }}
        onChange={(itemSelected: any) => onChange(itemSelected)}
        options={breedsList as never[]}
        //placeholder='Please choose a breed'
        isLoading={isLoading}
        selected={singleSelections}
        onFocus={onFocus}
        onBlur={onBlur}
        onSearch={() => {
          // setIsLoading(true);
        }}
        isInvalid={isInvalid && isTouched}
        isValid={isTouched && !isInvalid}
      />
      {isInvalid && isTouched && (
        <div className='invalid-feedback d-block'>Please choose a breed</div>
      )}
    </div>
  );
}